import React, { useEffect, useState } from "react";

const getGreeting = () => {
  const hour = new Date().getHours();
  if (hour < 12) return "Good Morning";
  if (hour < 17) return "Good Afternoon";
  return "Good Evening";
};

const Greeting = ({
  name = localStorage.getItem("firstName") +
    " " +
    localStorage.getItem("lastName"),
}) => {
  const [greeting, setGreeting] = useState("");

  useEffect(() => {
    setGreeting(getGreeting());
  }, []);

  return (
    <div className='greeting-container'>
      <h4>Hello {name} 👋</h4>
      <p>{greeting}</p>
    </div>
  );
};

export default Greeting;
